
// Parsley (validation)
import 'parsleyjs/dist/parsley.min.js';
